document.addEventListener("alpine:init", () => {
  const contentMap =
    ATAR_JOURNEY_DATA.atarAdjustmentCalculator.appContentSelectors;

  const appContent = {};
  Object.keys(contentMap).forEach(
    (k) =>
      (appContent[k] = document.querySelector(contentMap[k])
        ? document.querySelector(contentMap[k]).innerHTML
        : "")
  );

  Alpine.data("atarAdjustmentCalculator", () => ({
    appContent,
  }));
});

var elATAR = document.querySelector("#atar");
var bonusFields;
var bonusAtar = document.querySelector("#bonus-atar");
var bonusAtarEnd = document.querySelector("#bonus-atar-end");
var atarWizDiscipline = document.querySelector("#atar-wiz-discipline");
var atarWizLocation = document.querySelector("#atar-wiz-location");
var atarAdjustmentPoints = document.querySelector("#atar-adjust-calc");
var address = "";
var suburb = "";
var postcode = "";
var state = "";
var lng = 0;
var lat = 0;
var APIBase = "/atar/wizard/api";

// TODO: use alpine store to get ATAR
atarAdjustmentPoints.style.display = "none";

function _onChange_formFields() {
  updateScore(this);

  atarAdjustmentPoints.style.display = "block";
}

function _delay(callback, ms) {
  var timer = 0;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(context, args);
    }, ms || 0);
  };
}

function _initializeForm() {
  document
    .querySelector("#atar")
    .addEventListener("keyup", _delay(_onChange_formFields, 500), false);

  bonusFields = document.querySelectorAll(".bonus-field");

  for (i = 0; i < bonusFields.length; ++i) {
    bonusFields[i].addEventListener("change", _onChange_formFields, false);
  }

  // make sure initAutocomplete() is called.
  initAutocomplete();
}

function updateScore(eventInput) {
  var elATAR = document.querySelector("#atar");

  var oriATAR = elATAR.value.trim();
  var atar = parseFloat(oriATAR);

  if (!oriATAR.match(/^\d+(\.|\.\d+)?$/) || isNaN(atar)) {
    if (isNaN(atar)) {
      elATAR.value = "";
    } else if (elATAR.value < 0) {
      elATAR.value = 0;
    } else if (elATAR.value > 99.95) {
      elATAR.value = 99.95;
    }

    elATAR.focus();

    bonusAtar.classList.add("hidden");
    if (bonusAtarEnd) {
      bonusAtarEnd.classList.add("hidden");
    }

    if (eventInput.name === "atar" && eventInput.value !== "") {
      alert("Please input a valid ATAR value");
    }

    return false;
  } else {
    bonusAtar.classList.remove("hidden");
    if (bonusAtarEnd) {
      bonusAtarEnd.classList.remove("hidden");
    }
  }

  var questionData = [];
  for (i = 0; i < bonusFields.length; ++i) {
    var currentField = bonusFields[i];
    if (currentField.dataset.type == "r" && currentField.checked == true) {
      questionData.push({
        type: currentField.dataset.type,
        value: currentField.value,
      });
    }
    if (currentField.dataset.type !== "r") {
      questionData.push({
        type: currentField.dataset.type,
        value: currentField.value,
      });
    }
  }

  var postData = {
    atar: atar <= 0 ? 0.05 : atar, // backend does not allow zero
    address: address,
    suburb: suburb,
    state: state,
    postcode: postcode,
    questions: questionData,
    lng: lng,
    lat: lat,
  };

  console.log("atar", atar, "postData", postData);
  var httpRequest;
  httpRequest = new XMLHttpRequest();

  if (!httpRequest) {
    alert("Giving up :( Cannot create an XMLHTTP instance");
    return false;
  }
  httpRequest.onreadystatechange = updateAtar;
  httpRequest.open("POST", APIBase + "/calculator/points");
  httpRequest.setRequestHeader(
    "Content-Type",
    "application/json;charset=UTF-8"
  );
  httpRequest.send(JSON.stringify(postData));

  function updateAtar() {
    if (httpRequest.readyState === XMLHttpRequest.DONE) {
      if (httpRequest.status === 200) {
        var result = JSON.parse(httpRequest.responseText);

        var _newAtarText =
          result.newATAR < 30 ? "< 30" : result.newATAR.toString();

        bonusAtar.lastChild.textContent = _newAtarText;

        const newAtarNumber = parseFloat(result.newATAR);

        var elBonusAtarEndPoint = document.getElementById(
          "bonus-atar-end-point"
        );
        if (elBonusAtarEndPoint) {
          elBonusAtarEndPoint.textContent = result.newATAR;
          // TODO: add atar to alpine store?
          Alpine.store("atarCalculator").adjustedATAR = newAtarNumber;
        }

        var adjustmentPoints = result.adjustmentPoints;

        document.querySelector("#adjustment-points > span").textContent =
          adjustmentPoints;

        Alpine.store("atarCalculator").estimateAdjustedATAR = newAtarNumber;

        if (adjustmentPoints > 0) {
          document.querySelector(".maxed-points").classList.remove("hidden");
          document.querySelector(".points-message").textContent =
            "(aggregate score)";
        } else {
          document.querySelector(".maxed-points").classList.add("hidden");
          document.querySelector(".points-message").textContent = "";
        }

        Alpine.store("atarCalculator").adjustmentPoints = adjustmentPoints;

        //  TODO: use Alpine store
        window.localStorage.setItem("ATAR", oriATAR);
        window.localStorage.setItem("adjustedATARScore", result.newATAR);
      } else {
        alert("We could not load the adjusted ATAR. Try refreshing the page.");
      }
    }
  }

  return true;
}

// Google Address Autocomplete
var placeSearch, autocomplete;

function initAutocomplete() {
  if (
    typeof google === "undefined" ||
    typeof google.maps === "undefined" ||
    typeof google.maps.places === "undefined"
  ) {
    return;
  }

  if (autocomplete) {
    return;
  }

  var elSearch = document.querySelector('[data-type="it-ral"]');

  if (!elSearch) {
    return;
  }

  // Create the autocomplete object, restricting the search to geographical location types.
  autocomplete = new google.maps.places.Autocomplete(
    /** @type {!HTMLInputElement} */ (elSearch),
    {
      types: ["address"],
      componentRestrictions: { country: "au" },
      fields: ["address_components", "geometry"],
    }
  );

  // When the user selects an address from the dropdown, populate the address fields in the form.
  autocomplete.addListener("place_changed", fillInAddress);

  elSearch.addEventListener("change", function () {
    if (elSearch.value === "") {
      _cleanAddressValues();
      updateScore();
    }
  });
}

function _cleanAddressValues() {
  address = "";
  suburb = "";
  postcode = "";
  state = "";

  lng = null;
  lat = null;
}

function fillInAddress() {
  _cleanAddressValues();

  // Get the place details from the autocomplete object.
  var place = autocomplete.getPlace();

  lng = place.geometry.location.lng();
  lat = place.geometry.location.lat();

  // Get each component of the address from the place details and fill the corresponding field on the form.
  for (var i = 0; i < place.address_components.length; i++) {
    var addressType = place.address_components[i].types[0];
    switch (addressType) {
      case "street_number":
        address += place.address_components[i]["long_name"] + " ";
        break;
      case "route":
        address += place.address_components[i]["long_name"];
        break;
      case "locality":
        suburb = place.address_components[i]["long_name"];
        break;
      case "administrative_area_level_1":
        state = place.address_components[i]["short_name"];
        break;
      case "postal_code":
        postcode = place.address_components[i]["long_name"];
        break;
    }
  }

  if (address !== "" && postcode !== "") {
    updateScore();
    _checkAndShowCampusInput();
  }
}

// Bias the autocomplete object to the user's geographical location, as supplied by the browser's 'navigator.geolocation' object.
function _geolocateLocationBiasing() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      var geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      var circle = new google.maps.Circle({
        center: geolocation,
        radius: position.coords.accuracy,
      });
      autocomplete.setBounds(circle.getBounds());
    });
  }
}

function _checkAndShowCampusInput() {
  var postData = {
    postcode: postcode,
  };

  var httpRequest;
  httpRequest = new XMLHttpRequest();

  if (!httpRequest) {
    alert("Giving up :( Cannot create an XMLHTTP instance");
    return false;
  }

  var _cb = function () {
    if (httpRequest.readyState === XMLHttpRequest.DONE) {
      if (httpRequest.status === 200) {
        var result = JSON.parse(httpRequest.responseText);

        document
          .querySelector("#campusFormControl")
          .classList[result.data ? "remove" : "add"]("hidden");
      } else {
        alert("There was a problem with the request.");
      }
    }
  };

  httpRequest.onreadystatechange = _cb;
  httpRequest.open(
    "POST",
    APIBase + "/calculator/check-regional-grant-eligibility"
  );
  httpRequest.setRequestHeader(
    "Content-Type",
    "application/json;charset=UTF-8"
  );
  httpRequest.send(JSON.stringify(postData));
}

function _setupForm(questionData) {
  //questionData.reverse().map(_addQuestionToForm);
  questionData.map(_addQuestionToForm);

  _initializeForm();

  setTimeout(function () {
    if (typeof initTooltips === "function") {
      initTooltips();
    }
  }, 1000);
}

function _addQuestionToForm(data, index) {
  var children = [];

  var qId = "q-" + index;

  // Ignore subject assessments question
  if (qId !== "q-7") {
    if (data.heading) {
      var elHeading = document.createElement("h4");
      elHeading.classList.add("h5");
      elHeading.innerHTML = `${index + 1}. ${data.heading}`;

      // TODO: remove q-2 from API
      if (index >= 2) {
        elHeading.innerHTML = `${index}. ${data.heading}`;
      }

      if (qId === "q-8") {
        var elHeading = document.createElement("h4");
        elHeading.innerHTML = "Step 4: " + data.heading;
      }

      if (qId === "q-9") {
        console.log(qId);
        var elHeading = document.createElement("h4");
        elHeading.innerHTML =
          "Step 5: Elite Athlete Program adjustments (Optional)";
        console.log("10", elHeading);
      }

      children.push(elHeading);

      if (qId === "q-8") {
        // var hr = document.createElement("hr");
        // hr.style.margin = "1rem 0";

        // var priorityAccessDescription = document.createElement("div");
        // priorityAccessDescription.classList.add("ds-block");
        // priorityAccessDescription.style.marginBottom = "1rem";

        // priorityAccessDescription.innerHTML =
        //   '<p>What is Priority Access VCE Aggregate Adjustment Factors and how does it work? <button class="ds-btn-link ds-icon-chevron-down ds-collapse__trigger" aria-controls="priority-access-explanation" aria-expanded="false">Read more</button></p><div id="priority-access-explanation" class="ds-collapse__content" role="region" hidden><p>[more content]</p></div>';

        // children.push(priorityAccessDescription);

        // priorityAccessDescription.querySelector(".ds-btn-link").addEventListener(
        //   "click",
        //   function (e) {
        //     var descriptionState = e.target.getAttribute("aria-expanded");
        //     if (descriptionState === "false") {
        //       descriptionState = "true";
        //     } else {
        //       descriptionState = "false";
        //     }

        //     e.target.setAttribute("aria-expanded", descriptionState);
        //     e.target.parentNode.nextElementSibling.hidden =
        //       !e.target.parentNode.nextElementSibling.hidden;
        //   },
        //   true
        // );

        var priorityAccessHeading = document.createElement("h4");
        priorityAccessHeading.classList.add("h5");
        priorityAccessHeading.classList.add("sr-only");
        priorityAccessHeading.textContent =
          "Priority Access VCE Aggregate Adjustment Factors";

        children.push(priorityAccessHeading);
      }

      if (qId === "q-9") {
        // var hr = document.createElement("hr");
        // hr.style.margin = "1rem 0";

        var eliteAthleteDescription = document.createElement("div");
        eliteAthleteDescription.classList.add("ds-block");

        eliteAthleteDescription.innerHTML =
          '<p>What are Elite Athlete Program adjustments and how do I apply? <button class="ds-btn-link ds-icon-chevron-down ds-collapse__trigger" aria-controls="elite-athlete-explanation" aria-expanded="false">Read more</button></p><div id="elite-athlete-explanation" class="ds-collapse__content" role="region" hidden><p>If you’re an elite athlete applying for entry into a La Trobe undergraduate course via VTAC, you could be eligible for the Elite Athlete Adjustment Factor. This means you may have a five aggregate point adjustment factor applied to your admission to La Trobe.</p><p><a href="https://www.latrobe.edu.au/sport/elite-athlete/adjustment-factor-application">How to apply for the Elite Athlete Adjustment Factor</a></p></div>';

        children.push(eliteAthleteDescription);

        // eliteAthleteDescription.querySelector(".ds-btn-link").addEventListener(
        //   "click",
        //   function (e) {
        //     var descriptionState = e.target.getAttribute("aria-expanded");
        //     if (descriptionState === "false") {
        //       descriptionState = "true";
        //     } else {
        //       descriptionState = "false";
        //     }

        //     e.target.setAttribute("aria-expanded", descriptionState);
        //     e.target.parentNode.nextElementSibling.hidden =
        //       !e.target.parentNode.nextElementSibling.hidden;
        //   },
        //   true
        // );

        var eliteAthleteHeading = document.createElement("h4");
        eliteAthleteHeading.classList.add("h5");
        eliteAthleteHeading.textContent =
          "Elite Athlete ATAR adjustment applications";

        // children.push(hr);
        children.push(eliteAthleteHeading);
      }
    }

    if (data.description) {
      if (data.type === "r") {
        var elDescription = document.createElement("p");
      } else {
        var elDescription = document.createElement("label");
        elDescription.setAttribute("for", qId);
      }

      elDescription.classList.add("input-description");
      elDescription.innerHTML = data.description;

      children.push(elDescription);
    }

    if (data.question) {
      var elQTxt = document.createElement("p");
      elQTxt.classList.add("ds-label");
      elQTxt.setAttribute("style", "font-weight: normal; margin: 1rem;");
      elQTxt.setAttribute("for", qId);
      elQTxt.innerHTML = data.question;

      if (qId === "q-10") {
        elQTxt.setAttribute("style", "font-weight: normal; margin: 1rem 0;");
      }

      children.push(elQTxt);
    }
  }

  var elInput;

  switch (data.type) {
    case "it-ral":
    case "it-psl":
      elInput = document.createElement("input");
      elInput.classList.add("ds-text-input");
      elInput.id = qId;
      elInput.name = qId;
      elInput.setAttribute("data-type", data.type);
      elInput.type = "search";
      if (data.inputPlaceholder) {
        elInput.placeholder = data.inputPlaceholder;
        elInput.autocomplete = "off";
      }

      if (data.type === "it-ral") {
        elInput.addEventListener("focus", _geolocateLocationBiasing);
      }

      children.push(elInput);

      break;
    // <select>
    case "s-c":
    case "s":
      elInput = document.createElement("select");
      elInput.classList.add("ds-select");
      elInput.id = qId;
      elInput.name = qId;
      elInput.setAttribute("data-type", data.type);
      elInput.classList.add("bonus-field");
      elInput.classList.add("auto");

      if (data.options) {
        data.options.forEach(function (option) {
          var elOpt = document.createElement("option");
          elOpt.value = option.id;
          elOpt.text = option.option;
          if (option.isDefault) {
            elOpt.selected = true;
          }

          elInput.appendChild(elOpt);

          // if (qId === 'q-7') {
          //     if (option.option === window.localStorage.getItem('ATARSubjectAssessmentPoints')) {
          //         elOpt.selected = true;
          //         elInput.setAttribute('disabled', 'true');
          //     }
          // }
        });
      }

      children.push(elInput);

      break;
    case "r":
      if (data.options) {
        data.options.forEach(function (option, optionIndex) {
          elInput = document.createElement("input");

          if (option.isDefault) {
            elInput.checked = true;
          }

          elInput.id = qId + "-a-" + optionIndex;
          elInput.type = "radio";
          elInput.classList.add("ds-input-radio");
          elInput.classList.add("ds-input-radio--toggle");

          if (qId === "q-5" || qId === "q-6") {
            elInput.classList.add("ds-input-radio--track");
          }

          elInput.name = qId;
          elInput.value = option.id;
          elInput.setAttribute("data-type", data.type);
          elInput.classList.add("bonus-field");

          children.push(elInput);

          var elInputLbl = document.createElement("label");
          elInputLbl.classList.add("ds-label");

          if (qId === "q-5" || qId === "q-6") {
            elInputLbl.classList.add("ds-label--track");
          }

          elInputLbl.setAttribute("for", elInput.id);
          elInputLbl.innerHTML = option.option;

          if (elInputLbl.innerHTML === "Low-medium") {
            elInputLbl.innerHTML = "Medium-low";
          }

          children.push(elInputLbl);

          children.push(document.createTextNode("\u00A0"));
        });
      }

      break;
  }

  if (data.reference) {
    var elReference = document.createElement("p");
    elReference.innerHTML = data.reference ? data.reference : "";
    elReference.classList.add("input-reference-container");
    // elReference.classList.add("ds-small");
    children.push(elReference);
  }

  var elContainer = document.createElement("div");
  elContainer.classList.add("form-control");

  // if (qId === "q-10") {
  //   elContainer.classList.add("ds-hero-promo__peakaboo");
  //   elContainer.classList.add("ds-hero-promo__peakaboo--narrow");
  // }

  if (data.type === "s-c") {
    elContainer.classList.add("hidden");
    elContainer.id = "campusFormControl";
  }

  children.forEach(function (child) {
    elContainer.appendChild(child);
  });

  var target = document.querySelector("#atar-adjust-calc-form fieldset");

  if (qId === "q-10") {
    document
      .querySelector("#atar-adjust-calc-form")
      .insertAdjacentElement("afterend", elContainer);
  } else {
    target.appendChild(elContainer);
  }
}

// setup form questions
document.addEventListener("DOMContentLoaded", function (event) {
  var httpRequest;
  httpRequest = new XMLHttpRequest();

  if (!httpRequest) {
    alert("Giving up :( Cannot create an XMLHTTP instance");
    return false;
  }

  httpRequest.onreadystatechange = function () {
    if (httpRequest.readyState === XMLHttpRequest.DONE) {
      if (httpRequest.status === 200) {
        _setupForm(JSON.parse(httpRequest.responseText));
      } else {
        alert("There was a problem with the request.");
      }
    }
  };

  httpRequest.open("GET", APIBase + "/calculator/questions");
  httpRequest.setRequestHeader(
    "Content-Type",
    "application/json;charset=UTF-8"
  );
  httpRequest.send();
});

document
  .querySelector('button[aria-controls="atar-explanation"]')
  .addEventListener("click", shiftStickyPosition);

function shiftStickyPosition() {
  document
    .querySelector("#atar-section")
    .classList.toggle("expanded-sticky-position");
}

window.initAutocomplete = initAutocomplete;
